<template>
  <div id="userManagementForAdmin">
    <div class="container UserManagementForAdmin">
      <div class="datatable-edit__header">
        <h2>User Management</h2>
      </div>
      <el-tabs v-model="flexiTabValue" type="card" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in flexiTab"
          :key="item.name"
          :label="item.title"
          :name="item.name"
        >

          <div v-if="index == 0">
            {{ item.content }}
            <div class="">
              <h5 class="text-left student-form__title" id="createUserAcc">
                Create User Account
              </h5>
            </div>
            <div class="row form-group__wrapper">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>Creation Date</label>
                <div class="date">
                  <el-date-picker
                    v-model="inputCurrentDate"
                    type="date"
                    format="dd/MM/yyyy"
                    class="UserManagementForAdmin"
                    value-format="dd/MM/yyyy"
                    placeholder=""
                    disabled
                  ></el-date-picker>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>Created By</label>
                <div class="date">
                  <el-input
                    v-model="inputCreatedBy"
                    type="text"
                    :disabled="true"
                  ></el-input>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>*Salutation</label>
                <select
                  v-model="ddlSalutation"
                  :class="{ requiredFields: $v.ddlSalutation.$error }"
                  class="form-control pro-edt-select form-control-primary"
                >
                  <option value="" disabled selected>Please Select</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                </select>
                <div class="requiredFieldsMsg" v-if="$v.ddlSalutation.$error">
                  Salutation required
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>*Employee Name</label>
                <input
                  v-model="inputEmployeeName"
                  :class="{ requiredFields: $v.inputEmployeeName.$error }"
                  class="form-control pro-edt-select form-control-primary"
                />
                <div
                  class="requiredFieldsMsg"
                  v-if="$v.inputEmployeeName.$error"
                >
                  Employee Name required
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>*Date Of Birth</label>
                <div class="date">
                  <el-date-picker
                    v-model="inputDOB"
                    type="date"
                    :class="{ requiredFields: $v.inputDOB.$error }"
                    format="dd/MM/yyyy"
                    class="UserManagementForAdmin"
                    value-format="dd/MM/yyyy"
                    placeholder=""
                  ></el-date-picker>
                </div>
                <div class="requiredFieldsMsg" v-if="$v.inputDOB.$error">
                  Date Of Birth required
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>Alias</label>
                <input
                  v-model="inputAlias"
                  class="form-control pro-edt-select form-control-primary"
                />
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>*Gender</label>
                <select
                  v-model="selectedGender"
                  :class="{ requiredFields: $v.selectedGender.$error }"
                  class="form-control pro-edt-select form-control-primary"
                >
                  <option value="" disabled selected>Please Select</option>
                  <option value="Female">Female</option>
                  <option value="Male">Male</option>
                </select>
                <div class="requiredFieldsMsg" v-if="$v.selectedGender.$error">
                  Gender required
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>*Employee Type</label>
                <select
                  v-model="selectedEmployeeType"
                  :class="{ requiredFields: $v.selectedEmployeeType.$error }"
                  class="form-control pro-edt-select form-control-primary"
                >
                  <option value="" disabled selected>Please Select</option>
                  <option v-for="item in employeeTypeList">
                    {{ item.CONType }}
                  </option>
                </select>
                <div
                  class="requiredFieldsMsg"
                  v-if="$v.selectedEmployeeType.$error"
                >
                  Employee Type required
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>*Corporate</label>
                <select
                  v-on:change="corporateClick()"
                  v-model="selectedCorporate"
                  :class="{ requiredFields: $v.selectedCorporate.$error }"
                  class="form-control pro-edt-select form-control-primary"
                >
                  <option value="" disabled selected>Please Select</option>
                  <option value="UTY20110000001">Head Quarters</option>
                  <option value="UTY201300000061">Etonhouse Singapore</option>
                  <option value="UTY201300000072" disabled selected>
                    Etonhouse China
                  </option>
                  <option value="UTY201300000075" disabled selected>
                    Etonhouse Hong Kong
                  </option>
                  <option value="UTY201300000086">Etonhouse Franchisee</option>
                </select>
                <div
                  class="requiredFieldsMsg"
                  v-if="$v.selectedCorporate.$error"
                >
                  Corporate required
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>*Email</label>
                <el-input
                  v-model="inputUserEmail"
                  :class="{ requiredFields: $v.inputUserEmail.$error }"
                  type="text"
                ></el-input>
                <div class="requiredFieldsMsg" v-if="$v.inputUserEmail.$error">
                  Email required
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>*Center</label>
                <el-select
                  v-model="selectedSchoolID"
                  style="width: 100%"
                  multiple
                  placeholder="Please Select"
                >
                  <el-option
                    v-for="(item, index) in schoolNameList"
                    :value="item.SchoolID"
                    :label="item.SchoolName"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>Staff Discount</label>
                <select
                  v-model="selectedStaffDiscount"
                  class="form-control pro-edt-select form-control-primary"
                >
                  <option value="" disabled selected>Please Select</option>
                  <option value="Amount">Amount</option>
                  <option value="Percentage">Percentage</option>
                </select>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>Proposed By</label>
                <el-input
                  v-model="inputProposedBy"
                  type="text"
                  disabled
                ></el-input>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>Proposed Date</label>
                <el-input
                  v-model="inputProposedDate"
                  type="text"
                  disabled
                ></el-input>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>Approved By</label>
                <el-input
                  v-model="inputApprovedBy"
                  type="text"
                  disabled
                ></el-input>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" disabled>
                <label>Approved Date</label>
                <el-input
                  v-model="inputApprovedDate"
                  type="text"
                  disabled
                ></el-input>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>Agreement Sent By</label>
                <el-input
                  v-model="inputAgreementSentBy"
                  type="text"
                  disabled
                ></el-input>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <label>*Date Of Joining</label>
                <el-date-picker
                  v-model="inputDateOfJoin"
                  type="date"
                  format="dd/MM/yyyy"
                  class="UserManagementForAdmin"
                  :class="{ requiredFields: $v.inputDateOfJoin.$error }"
                  value-format="dd/MM/yyyy"
                  placeholder=""
                ></el-date-picker>
                <div class="requiredFieldsMsg" v-if="$v.inputDateOfJoin.$error">
                  Date Of Joining required
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <br />
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <el-button
                  class="float-right"
                  style="width: 100px"
                  v-on:click="Validation()"
                  type="primary"
                  >Create</el-button
                >
              </div>
            </div>
          </div>

          <div v-if="index == 1">
            {{ item.content }}
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <label>Corporate</label>
                <select
                  v-on:change="corporateClick()"
                  v-model="selectedCorporate"
                  class="form-control pro-edt-select form-control-primary"
                >
                  <option value="" disabled selected>Please Select</option>
                  <option value="UTY201300000061">Etonhouse Singapore</option>
                  <option value="UTY20110000001">Head Quarters</option>
                  <option value="UTY201300000072" disabled>
                    Etonhouse China
                  </option>
                  <option value="UTY201300000075" disabled>
                    Etonhouse Hong Kong
                  </option>
                  <option value="UTY201300000086">Etonhouse Franchisee</option>
                </select>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <label>Center</label>
                <el-select
                  v-model="pendingListSelectedSchoolID"
                  style="width: 100%"
                  clearable
                  placeholder="Please Select"
                >
                  <el-option
                    v-for="(item, index) in schoolNameList"
                    :value="item.SchoolID"
                    :label="item.SchoolName"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <label>Status</label>
                <el-select
                  v-model="listStatus"
                  style="width: 100%"
                  clearable
                  placeholder="Please Select"
                >
                  <el-option
                    v-for="(item, index) in StatusList"
                    :value="item.value"
                    :label="item.label"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <label>Username</label>
                <div class="row">
                  <div class="col">
                    <el-input
                      v-model="txtCONnameLike"
                      placeholder="Enter Username"
                    ></el-input>
                  </div>
                  <div class="col">
                    <el-button
                      class="float-left"
                      type="primary"
                      @click="getUserListBySchool"
                      >Search</el-button
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <el-button
                  v-if="
                    (spdSelection.length > 0 && listStatus === 'Pending') ||
                    (spdSelection.length > 0 && listStatus === 'Deleted')
                  "
                  class="float-right"
                  type="primary"
                  v-on:click="setUserStatusbtn('Active')"
                  >Set Active</el-button
                >
                <el-button
                  v-if="spdSelection.length > 0 && listStatus === 'Active'"
                  class="float-right"
                  type="primary"
                  v-on:click="setUserStatusbtn('Deleted')"
                  >Delete User Account</el-button
                >
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div v-if="currentPendingListInt" class="datatable_group">
                  <data-tables
                    :data="currentPendingListInt"
                    @selection-change="changeSelection"
                    :action-col="currentPendingAction"
                  >
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column
                      v-for="item in currentPendingList"
                      :prop="item.prop"
                      :label="item.label"
                      :key="item.prop"
                      sortable="custom"
                    >
                    </el-table-column>
                  </data-tables>
                </div>
                <div v-else>
                  <strong>{{ startupText }}</strong>
                  <img src="../assets/notfound.png" />
                </div>
              </div>
              <div />
            </div>
          </div>

          <div v-if="index == 2" class="container">
            {{ item.content }}
            <div class="row">
              <div class="col-sm-8">
                <div class="">
                  <h5 class="text-left student-form__title" id="viewUserDetail">
                    User Detail
                  </h5>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                  <label>Switch School</label>
                  <select
                    @change="
                      getUserDetail(
                        '',
                        selectedUserDetailSchoolID,
                        txtEmployeeEmail
                      )
                    "
                    class="form-control"
                    v-model="selectedUserDetailSchoolID"
                  >
                    <option value="" selected disabled>Select here</option>
                    <option
                      v-for="(item, index) in ddlSchoolForUserDetailList"
                      :value="item.SchoolID"
                      placeholder="Switch School"
                      :key="index"
                    >
                      {{ item.SchoolName }}
                    </option>
                  </select>
                </div>

                <div class="row form-group__wrapper">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label>Status</label>
                    <input
                      v-if="txtEmployeeStatus === 'Active'"
                      v-model="txtEmployeeStatus"
                      type="text"
                      class="form-control"
                      style="background-color: green; color: white"
                      placeholder=""
                      disabled
                    />
                    <input
                      v-else-if="txtEmployeeStatus === 'Pending'"
                      v-model="txtEmployeeStatus"
                      type="text"
                      class="form-control"
                      style="background-color: Yellow"
                      placeholder=""
                      disabled
                    />
                    <input
                      v-else
                      v-model="txtEmployeeStatus"
                      type="text"
                      class="form-control"
                      style="background-color: white"
                      placeholder=""
                      disabled
                    />
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Employee Name</label>
                    <div class="">
                      <input
                        v-model="txtEmployeeName"
                        type="text"
                        class="form-control"
                        placeholder=" "
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Employee Email</label>
                    <div class="">
                      <input
                        v-model="txtEmployeeEmail"
                        type="text"
                        class="form-control"
                        placeholder=" "
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Employee Alias</label>
                    <div class="">
                      <input
                        v-model="txtEmployeeAlias"
                        type="text"
                        class="form-control"
                        placeholder=" "
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Employee Type</label>
                    <div class="">
                      <input
                        v-model="txtEmployeeType"
                        type="text"
                        class="form-control"
                        placeholder=" "
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Gender</label>
                    <div class="">
                      <input
                        v-model="txtEmployeeGender"
                        type="text"
                        class="form-control"
                        placeholder=" "
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>School</label>
                    <div class="">
                      <input
                        v-model="txtSchoolName"
                        type="text"
                        class="form-control"
                        placeholder=" "
                        disabled
                      />
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Staff Discount</label>
                    <div class="row">
                      <div class="col" style="width: 100%">
                        <input
                          v-model="txtStaffDiscountValue"
                          type="text"
                          class="form-control"
                          placeholder="enter"
                        />
                      </div>
                      <div class="col">
                        <select
                          v-model="ddlselectedDiscountType"
                          class="form-control"
                          placeholder="Select"
                        >
                          <option selected disabled>Please Select</option>
                          <option value="Percentage">Percentage</option>
                          <option value="Amount">Amount</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Created Date</label>
                    <div class="">
                      <input
                        v-model="txtCreatedDate"
                        type="text"
                        class="form-control"
                        placeholder=" "
                        disabled
                      />
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="" style="text-align:left">
                      <el-button @click="updateUserDetail" type="primary"
                        >Update Account Detail</el-button
                      >
                    </div>
                  </div>

                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <hr>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Login ID</label>
                    <div class="">
                      <input
                        v-model="txtLoginID"
                        type="text"
                        class="form-control"
                        placeholder=" "
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <label>Password</label>
                    <div class="">
                      <input
                        v-model="txtPassword"
                        type="text"
                        class="form-control"
                        placeholder=" "
                      />
                    </div>
                  </div>
                  
                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div class="" style="text-align:left">
                      <el-button @click="updateLoginDetail" type="primary"
                        >Update Login</el-button
                      >
                    </div>
                  </div>

                  <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"></div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <data-tables layout="table" :data="thisUserGroupListInt">
                      <el-table-column
                        v-for="item in thisUserGroupList"
                        :label="item.label"
                        :key="item.prop"
                        :prop="item.prop"
                      >
                      </el-table-column>
                    </data-tables>
                  </div>
                </div>
              </div>
              <div class="col-sm-4">
                <data-tables
                  layout="table"
                  :data="userGroupListInt"
                  @selection-change="changeSelection"
                >
                  <el-table-column type="selection" width="55">
                  </el-table-column>
                  <el-table-column
                    v-for="item in userGroupList"
                    :label="item.label"
                    :key="item.prop"
                    :prop="item.prop"
                  >
                  </el-table-column>
                </data-tables>
                <el-button
                  style="width: 100%"
                  v-on:click="assignUserGroup()"
                  type="warning"
                  >Assign Group</el-button
                >
              </div>
            </div>

            <!-- <div v-else>
               <strong>{{ startupText }}</strong>
                  <img src="../assets/notfound.png" />
            </div> -->
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import DataSource from "../data/datasource";
import Vue from "vue";
import { lang } from "../locale/index";
import { required, email } from "vuelidate/lib/validators";

import Cookies from "js-cookie";
export default {
  name: "UserManagementForAdmin",
  validations: {
    ddlSalutation: { required },
    inputEmployeeName: { required },
    inputDOB: { required },
    selectedGender: { required },
    selectedEmployeeType: { required },
    selectedSchoolID: { required },
    inputUserEmail: { required, email },
    selectedCorporate: { required },
    inputDateOfJoin: { required },
  },
  data() {
    return {
      inputCurrentDate: "",
      inputCreatedBy: "",
      ddlSalutation: "",
      inputEmployeeName: "",
      inputDOB: "",
      inputAlias: "",
      selectedGender: "",
      selectedEmployeeType: "",
      employeeTypeList: [],
      schoolNameList: [],
      selectedSchoolID: [],
      inputUserEmail: "",
      selectedCorporate: "",
      selectedStaffDiscount: "",
      inputDateOfJoin: "",
      universityID: "",

      //todo: not in used
      inputProposedBy: "",
      inputProposedDate: "",
      inputApprovedBy: "",
      inputApprovedDate: "",
      inputAgreementSentBy: "",
      //todo: not in used

      flexiTab: [
        {
          title: "Create User",
          name: "1",
          content: "",
        },
        {
          title: "User List/Search User",
          name: "2",
          content: "",
        },
        {
          title: "View User Detail(Assigned Group)",
          name: "3",
          content: "",
        },
      ],
      flexiTabValue: "1",

      StatusList: [
        {
          label: "Active",
          value: "Active",
        },
        {
          label: "Pending",
          value: "Pending",
        },
        {
          label: "Deleted",
          value: "Deleted",
        },
      ],

      currentPendingListInt: [],
      currentPendingList: [
        {
          prop: "staffName",
          label: lang("User Name"),
        },
        {
          prop: "staffType",
          label: lang("User Type"),
        },
        {
          prop: "staffEmail",
          label: lang("Email"),
        },
        {
          prop: "staffStatus",
          label: lang("Status"),
        },
        {
          prop: "staffSchool",
          label: lang("School"),
        },
      ],
      currentPendingAction: {
        label: lang("Active"),
        props: {
          align: "center",
        },
        buttons: [
          {
            props: {
              type: "primary",
              icon: "el-icon-more",
            },
            handler: (row) => {
              //todo: get user detail con and usr
              if(this.spdSelection.length == 0)
              {
                    this.$notify.error({
                      title: "Failed",
                      message: "Please select at least 1 user",
                    });
              }
              else if(this.spdSelection.length > 1)
              {
                    this.$notify.error({
                    title: "Failed",
                    message: "Please select 1 user only to edit!",
                  });
              }
              else{
                this.getUserDetail(row.staffConID, '', "");
              }
              
            },
            label: lang("Detail"),
          },
        ],
      },
      spdSelection: [],
      delSelection: [],

      searchEmployeeName: "",
      searchEmployeeEmail: "",

      userGroupListInt: [],
      userGroupList: [
        {
          prop: "GRPname",
          label: lang("Group"),
        },
      ],

      //todo: Bind staff detail.
      txtEmployeeStatus: "",
      txtEmployeeName: "",
      txtEmployeeEmail: "",
      txtEmployeeAlias: "",
      txtEmployeeType: "",
      txtEmployeeGender: "",
      txtCreatedDate: "",
      txtLoginID: "",
      txtPassword: "",
      txtSchoolName: "",
      ddlSchoolForUserDetailList: [],
      selectedUserDetailSchoolID: "",
      txtUserDetailCONid: "",
      txtCONnameLike: "",
      txtStaffDiscountValue: "",
      ddlselectedDiscountType: "",
      txt123:'',

      currentUSRid: "",
      pendingListSelectedSchoolID: "",
      listStatus: "",
      startupText: "Not Found",

      thisUserGroupListInt: [],
      thisUserGroupList: [
        {
          prop: "GRPname",
          label: lang("Group"),
        },
        {
          prop: "USRcreationdate",
          label: lang("Account Creation Date"),
        },
      ],
    };
  },
  async created() {
    this.inputCreatedBy = Cookies.get("userNameSession");
    this.inputCurrentDate =
      new Date().getDate() +
      "/" +
      (new Date().getMonth() + 1) +
      "/" +
      new Date().getFullYear();
    await this.BindEmployeeTypeDropdown();
    await this.getUserGroup();
  },
  methods: {
    lang,
    async changeSelection(val) {
      this.spdSelection = val;
    },
    async deleteSelection(val) {
      this.delSelection = val;
    },
    handleClick(tab, event) {
      //     console.log(tab, event);
    },
    async BindEmployeeTypeDropdown() {
      const resp = await DataSource.shared.getEmployeeTypeDropdownList();
      if (resp) {
        this.employeeTypeList = resp.Table;
      }
    },
    async corporateClick() {
      try {
        this.BindSchoolDropdown(this.selectedCorporate);
      } catch (e) {
        this.results = e;
      }
    },
    async BindSchoolDropdown(val) {

      const resp = await DataSource.shared.getSchoolDropdownList(val);
      if (resp) {
        //    console.log( this.schoolNameList );
        this.schoolNameList = resp.Table;
      }
    },
    async Validation() {
      try {
        this.$v.$touch();

        if (this.$v.$error) {
          this.$notify.error({
            title: "Error",
            message: "Please fill in all * fields & at least one of ** field",
          });
          return;
        }
        await this.createNewStaffAccount();
      } catch (e) {
        this.results = e;
      }
    },
    async createNewStaffAccount() {
      let tempObj = {
        salutation: this.ddlSalutation,
        name: this.inputEmployeeName,
        alias: this.inputEmployeeName,
        gender: this.selectedGender,
        dob: this.inputDOB,
        status: "Pending",
        CONType: this.selectedEmployeeType,
        University: this.selectedCorporate,
        School: this.selectedSchoolID,
        Email: this.inputUserEmail,
      };
      const resp = await DataSource.shared.createNewStaffAccount(
        JSON.stringify(tempObj)
      );

      if (resp) {
        switch (resp.code) {
          case "99":
            this.$notify.error({
              title: "Error",
              message: "Error 99",
              type: "Error",
            });
            break;

          case "3":
            this.$notify.error({
              title: "Duplicate",
              message: "Duplicate email found in same school!",
              type: "Error",
            });
            break;

          case "1":
            this.$notify.success({
              title: "Success",
              message: "OK",
              type: "Success",
            });

            this.listStatus = "";
            this.pendingListSelectedSchoolID = "";

            this.flexiTabValue = "2";

            //todo get pending account
            this.getUserListBySchool("", "Pending", this.inputEmployeeName);
            //todo get pending accounts
            break;

          default:
            this.$notify.error({
              title: "Error",
              message: resp.code,
              type: "Error",
            });
        }
      }
    },

    async setUserStatusbtn(statusVal) {
      //todo: update pending status to "Active"
      const resp = await DataSource.shared.updateStaffAccountStatus(
        JSON.stringify(this.spdSelection),
        statusVal
      );
      if (resp) {
        if (resp.code === "99") {
          this.$notify.error({
            title: "Error",
            message: "99",
          });
        } else if (resp.code === '3') {
          this.$notify.error({
            title: "Empty Object",
            message: "Please select at least 1 item!",
          });
        } else if (resp.code === "1") {
          this.$notify.success({
            title: "OK",
            message: "OK" + "-" + statusVal,
          });

          this.getUserListBySchool(
            this.pendingListSelectedSchoolID,
            this.listStatus,
            ""
          );
        }
      }
    },
    async getUserGroup() {
      this.spdSelection = [];
      const resp = await DataSource.shared.getUserGroup();
      if (resp) {
        if (resp.code === "99") {
          console.log("99");
        } else if (resp.code === "88") {
          console.log("88");
        }
        else if(resp.code === "2")
        {
           this.$notify.error({
            title: "Error",
            message: "User Group not found!",
          });
        } 
        else {
          this.userGroupListInt = resp.Table;

          // console.log(this.userGroupListInt, "sadass");
        }
      }
    },
    async getUserDetail(conID, schoolID, CONEmail) {
      const resp = await DataSource.shared.getUserDetailsWithSchoolNameByCONID(
        conID,
        schoolID,
        CONEmail
      );
      if (resp) {
        if (resp.code === "99") {
          console.log("99");
        } else if (resp.code === "88") {
          console.log("88");
        } else if (resp.code === "2") {
          console.log("2");
          this.$notify.error({
            title: "Error",
            message: "Data issues, USRCONID not found! ",
          });
        } else if (resp.code === "3") {
          console.log("3");
          this.$notify.error({
            title: "Error",
            message: "Duplicate user email in same school! ",
          });
        } else {
          resp.Table.forEach((n) => {
            this.txtUserDetailCONid = n.CONid;
            this.txtEmployeeName = n.CONname;
            this.txtEmployeeEmail = n.CONEmail;
            this.txtEmployeeAlias = n.CONalias;
            this.txtEmployeeType = n.CONType;
            this.txtEmployeeGender = n.CONgender;
            this.txtCreatedDate = n.CONcreationdate;
            this.txtEmployeeStatus = n.CONstatus;
            this.txtLoginID = n.USRloginid;
            this.txtSchoolName = n.SCH_Short_Name;
  
            if(n.CONPerSalesCommision.toString()){this.txtStaffDiscountValue = n.CONPerSalesCommision;}
            if(n.CONPerSalesCommisionUnit){this.ddlselectedDiscountType = n.CONPerSalesCommisionUnit;}
            //this.txtPassword = n.USRpassword;
            if (n.USRid) {
              this.currentUSRid = n.USRid;
              this.flexiTabValue = "3";
              this.getUserGroupByUSRID(this.currentUSRid);
              if (!schoolID && !CONEmail) {
                this.getUserSchool(this.txtEmployeeEmail, n.CONstatus);
              }
            } else {
              this.$notify.error({
                title: "Error",
                message: "No USR ID!",
              });
            }
          });
        }
      }
    },
    async assignUserGroup() {
      if (this.spdSelection.length < 1) {
        this.$notify.error({
          title: "Error",
          message: "Please select at least 1 user group!",
        });
      } else {
        const resp = await DataSource.shared.assignUserGroup(
          JSON.stringify(this.spdSelection),
          this.currentUSRid
        );
        if (resp) {
          switch (resp.code) {
            case "99":
              break;
            case "88":
              break;
            case "1":
              this.$notify.success({
                title: "success",
                message: "success!",
              });
              this.spdSelection = [];
              await this.getUserGroupByUSRID(this.currentUSRid);
              break;

              default:
              this.$notify.error({
                title: "Failed",
                message: "Failed to add group!" + resp,
              });
          }
        }
      }
    },

    async getUserGroupByUSRID(usrID) {
      const resp = await DataSource.shared.getUserGroupByUSRID(usrID);

      if (resp) {
        if (resp.code === "99") {
          console.log("99");
        } else if (resp.code === "88") {
          console.log("88");
        } else {
          this.thisUserGroupListInt = resp.Table;
        }
      }
    },

    async getUserListBySchool(schVal, status, CONnameLike) {
      //this.pendingListSelectedSchoolID
      //this.listStatus
      //this.txtCONnameLike
      this.spdSelection = [];
      if (schVal && status) {
        const resp = await DataSource.shared.getUserListBySchool(
          schVal,
          status,
          ""
        );
        if (resp) {
          if (resp === "99") {
            console.log("99");
          } else if (resp === "88") {
            console.log("88");
          } else {
            this.currentPendingListInt = resp.Table;
          }
        }
      } else if (status && CONnameLike) {
        //todo route here when user account creation
        const resp = await DataSource.shared.getUserListBySchool(
          schVal,
          status,
          CONnameLike
        );
        if (resp) {
          if (resp === "99") {
            console.log("99");
          } else if (resp === "88") {
            console.log("88");
          } else {
            this.txtCONnameLike = CONnameLike;
            this.currentPendingListInt = resp.Table;
          }
        }
      } else {
        if (!this.selectedCorporate) {
          this.$notify.error({
            title: "Error",
            message: "Please select Corporate",
            type: "Error",
          });
        } else {
          this.$vs.loading();

          const resp = await DataSource.shared.getUserListBySchool(
            this.pendingListSelectedSchoolID,
            this.listStatus,
            this.txtCONnameLike
          );
          if (resp) {
            if (resp === "99") {
              console.log("99");
            } else if (resp === "88") {
              console.log("88");
            } else {
              this.currentPendingListInt = resp.Table;
            }
          }
        }
      }

      this.$vs.loading.close();
    },

    async updateUserDetail() {
      if (!this.txtUserDetailCONid || !this.currentUSRid) {
          alert("ID Empty!");
      } 
      else {
          let obj = {
            txtCONEmail: this.txtEmployeeEmail,
            txtEmployeeName: this.txtEmployeeName,
            txtEmployeeAlias: this.txtEmployeeAlias,
            txtEmployeeGender: this.txtEmployeeGender,
            txtDiscountValue: this.txtStaffDiscountValue,
            txtDiscountType: this.ddlselectedDiscountType,
            txtEmployeeType: this.selectedEmployeeType,
        };
          const resp = await DataSource.shared.updateUserDetail(
            this.txtUserDetailCONid,
            this.currentUSRid,
            this.txtLoginID,
            JSON.stringify(obj)
          );

        if (resp) {

          if (resp.code === "99") {
            this.$notify.error({
              title: "Error",
              message: "Error 99!",
            });
          }
          else if (resp.code === "2") {
            this.$notify.error({
              title: "Error",
              message: "Update Failed!",
            });
          } else if (resp.code === "3") {
            this.$notify.error({
              title: "Error",
              message: "Duplicated login ID!",
            });
          } else if (resp.code === "1") {
            this.$notify.success({
              title: "success",
              message: "Update successful!",
            });

            await this.getUserDetail(this.txtUserDetailCONid, '', '');
            await this.getUserGroupByUSRID(this.currentUSRid);
          }
        }
      }
    },

    async getUserSchool(CONEmailVal, CONStatus) {
      try {
        const resp = await DataSource.shared.getUserSchoolByCONEmail(
          CONEmailVal,
          CONStatus
        );
        if (resp) {
          if (resp.Table.length > 100) {
            alert("More than 100 schools!!!!check DB");
          } else {
            this.ddlSchoolForUserDetailList = resp.Table;
          }
        } else {
          console.log("Error");
        }
      } catch (e) {
        this.results = e;
      }
    },

    async updateLoginDetail()
    {
      const resp = await DataSource.shared.updateUserLoginDetail(this.txtUserDetailCONid,
            this.currentUSRid,
            this.txtLoginID,
            this.txtPassword);
            if(resp)
            {
               if (resp.code === "99")
                {
                this.$notify.error({
                  title: "Error",
                  message: "Error 99!",
                });
                }
                else if(resp.code === "1")
                {
                  this.$notify.success({
                  title: "success",
                  message: "Update successful!",
                  });
                  await this.getUserDetail(this.txtUserDetailCONid, '', '');
                  await this.getUserGroupByUSRID(this.currentUSRid);
                }
            }
         
    }

    //todo search
  },
};
</script>

<style scoped>
.requiredFieldsMsg {
  color: red;
  font-weight: bold;
}
input[type="text"][disabled] {
  color: black;
}
</style>
<style>
.UserManagementForAdmin .topbar {
  display: none;
}
.UserManagementForAdmin .el-input.is-disabled .el-input__inner {
  color: black;
}
</style>
